export default __webpack_public_path__ + "static/media/instagram.329ed9f9.svg";